const SORT_ORDERS = {
  asc: '',
  desc: '-',
}

export default class Sort {
  static get URL_PARAM() {
    return 'sort'
  }

  static get ASC() {
    return 'asc'
  }

  static get DESC() {
    return 'desc'
  }

  constructor(criteria) {
    this._field = null
    this._order = Sort.ASC
    this._criteria = criteria

    if (this._criteria) {
      this.parseCriteria()
    }
  }

  parseCriteria() {
    const params = this._criteria.match(
      // eslint-disable-next-line no-useless-escape
      new RegExp(`${Sort.URL_PARAM}=(.+?)\/`, 'i'),
    )

    if (params && params[1]) {
      this._field = params[1]
      this._order = Sort.ASC

      if (this._field.charAt(0) === '-') {
        this._field = this._field.substr(1)
        this._order = Sort.DESC
      }
    }
  }

  getSort() {
    return {
      field: this._field,
      order: this._order,
    }
  }

  get field() {
    return this._field
  }

  get order() {
    return this._order
  }

  setSort(field, order) {
    if (typeof field !== 'string') {
      throw new Error('Param [field] must be a string')
    }

    this._field = field
    this._order = order === Sort.DESC ? Sort.DESC : Sort.ASC
  }

  getCriteria() {
    return this._field
      ? `${Sort.URL_PARAM}=${SORT_ORDERS[this._order]}${this._field}/`
      : ''
  }

  getApiCriteria() {
    return this._field
      ? `${Sort.URL_PARAM}=${SORT_ORDERS[this._order]}${this._field}`
      : ''
  }
}
